module.exports = __webpack_public_path__ + "img/IncorrectAnsSmiley.2125ec72.svg";